import React from 'react';
import OsvRep from "../../components/reports/osv/OsvRep"


function DogovorPage(props) {
    return (
        <>
            <OsvRep />
        </>
    );
}

export default DogovorPage;